import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { HomePageRoutingModule } from './home-routing.module';

import { ComponentsModule } from 'src/app/shared/components/components.module';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { BalcaoComponent } from './balcao/balcao.component';
import { DeliveryComponent } from './delivery/delivery.component';
import { HomePage } from './home.page';
import { MesasComponent } from './mesas/mesas.component';
import { IntegracaoProdutosComponent } from '../integracao/integracaoprodutos.page';
import { IntegracaoPizzaLasanha } from 'src/app/shared/components/integracao-pizza-lasanha/integracao-pizza-lasanha.component';
import { GridGruposComponent } from '../integracao/grid-grupos/grid-grupos.component';
import { GridPizzasLasanhasComponent } from '../integracao/grid-pizzas-lasanhas/grid-pizzas-lasanhas.component';
import { GridProdutosComponent } from '../integracao/grid-produtos/grid-produtos.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TaxaEntregaComponent } from '../taxa-entrega/taxa-entrega.component';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ConfiguracaoImpressaoComponent } from '../configuracao-impressao/configuracao-impressao.page';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { NomeGrupoDilaog } from 'src/app/shared/components/nome-grupo-dialog/nome-grupo-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    declarations: [
        HomePage,
        MesasComponent,
        DeliveryComponent,
        BalcaoComponent,
        IntegracaoProdutosComponent,
        ConfiguracaoImpressaoComponent,
        TaxaEntregaComponent,
        GridGruposComponent,
        GridPizzasLasanhasComponent,
        GridProdutosComponent,
        IntegracaoPizzaLasanha,
        NomeGrupoDilaog,
    ],
    imports: [
        FormsModule,
        IonicModule.forRoot(),
        HomePageRoutingModule,
        ComponentsModule,
        DirectivesModule,
        PipesModule,
        MatButtonToggleModule,
        MatSlideToggleModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatProgressSpinnerModule,
        CommonModule,
        MatTableModule,
        MatCheckboxModule,
        MatButtonModule,
        MatSelectModule,
        MatDialogModule,
        MatTooltipModule,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    exports: [
        IntegracaoProdutosComponent,
        ConfiguracaoImpressaoComponent,
        TaxaEntregaComponent,
        GridGruposComponent,
        GridPizzasLasanhasComponent,
        GridProdutosComponent,
        IntegracaoPizzaLasanha
    ]
})
export class HomePageModule { }
